import { render, staticRenderFns } from "./payments-invoice-form.vue?vue&type=template&id=218427ca&"
import script from "./payments-invoice-form.vue?vue&type=script&lang=js&"
export * from "./payments-invoice-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports